import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { MeDto } from '@mafia/core';
import { ApiError, api } from '@/lib/api';
import { useAuth } from '@/store/auth';
import { Alert, Button } from './ui';

/** Аккаунтам, созданным до галочки (или при новой редакции согласия), — разовый запрос согласия поверх сайта. */
export function ConsentGate() {
  const { user, setUser, logout } = useAuth();
  const [checked, setChecked] = useState(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (!user || user.pdConsent) return null;

  async function accept() {
    setPending(true);
    setError(null);
    try {
      setUser(await api<MeDto>('/api/me/consent', { method: 'POST', body: { pdConsent: true } }));
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Сервер недоступен, попробуйте позже');
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm">
      <div role="dialog" aria-modal="true" aria-label="Согласие на обработку персональных данных" className="card w-full max-w-md space-y-4 p-6">
        <h2 className="font-display text-xl">Согласие на обработку данных</h2>
        <p className="text-sm text-zinc-400">
          Чтобы продолжить играть, подтвердите согласие на обработку ваших персональных данных: почты, логина, ника и игровой статистики.
        </p>
        <label className="flex cursor-pointer items-start gap-3 rounded-xl border border-white/5 bg-ink-850 px-3.5 py-3">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            className="mt-0.5 h-4 w-4 shrink-0 accent-gold-400"
          />
          <span className="text-sm text-zinc-300">
            Даю{' '}
            <Link to="/consent" target="_blank" className="link">
              согласие на обработку персональных данных
            </Link>{' '}
            и принимаю{' '}
            <Link to="/privacy" target="_blank" className="link">
              политику обработки
            </Link>
          </span>
        </label>
        {error && <Alert>{error}</Alert>}
        <Button className="w-full" disabled={!checked} loading={pending} onClick={() => void accept()}>
          Продолжить
        </Button>
        <p className="text-center text-sm text-zinc-500">
          Не согласны?{' '}
          <button type="button" onClick={() => void logout()} className="text-zinc-300 hover:text-white">
            Выйти
          </button>{' '}
          — удалить аккаунт можно по запросу оператору (контакты в политике).
        </p>
      </div>
    </div>
  );
}
